module.exports = __webpack_public_path__ + "static/media/SF-20-A (1).4235fb0f.mp3";